module.exports = __webpack_public_path__ + "img/close-white.b71d23f1.svg";